import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

fetch(environment.apiUrl + '/auth/appinfo/' + environment.appId.root + '/anonymous')
.then(res=>res.json())
.then(({config})=>{
  Object.assign(environment, config);
  Object.assign(environment.map, config.mapConfig);
  if (config.primaryColor) {
    document.documentElement.style
      .setProperty('--ion-color-primary', config.primaryColor);
  }
  if (config.secondaryColor) {
    document.documentElement.style
      .setProperty('--ion-color-secondary', config.secondaryColor);
  }

  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
})
